<template>
    <div id="app">
        <keep-alive>
            <router-view class="view-router" v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view class="view-router" v-if="!$route.meta.keepAlive"></router-view>
        <router-view name="tabbar"></router-view>
        <popupLogin/>
    </div>
</template>

<script>
    import popupLogin from '@/views/common/popupLogin'

    export default {
        components: {
            popupLogin
        },
        data() {
            return {}
        },
        created: function () {
        },
        mounted: function () {
            let loading = document.getElementById("Loading");
            if (loading != null) {
                document.body.removeChild(loading)
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
